import cfiLogic from 'utilities/cfiLogic';

/**
 * Creates a temporary animated spotlight effect on text that matches a given CFI.
 *
 * @method shineSpotlight
 * @param frameDocument
 * @param cfi
 * @returns a function to remove the spotlight if it still exists
 */
const shineSpotlight = (frameDocument, cfi) => {
  if (!frameDocument) {
    console.warn('Tried to shine a spotlight, but did not receive a document.');

    return;
  }

  // Remove any previous spotlight
  frameDocument.querySelector('.rs-spotlight')?.remove();

  const frameDocumentRect =
    frameDocument.documentElement.getBoundingClientRect();

  const range = cfiLogic.getRangeForCfi(frameDocument, cfi);

  if (range.collapsed) {
    console.warn(
      'Tried to shine a spotlight, but no text was found for the CFI',
      cfi,
    );

    return;
  }

  const rects = range.getClientRects();
  const svgElements = [];

  const SVG_SPEC_URL = 'http://www.w3.org/2000/svg';
  for (let rect of rects) {
    const svgElement = frameDocument.createElementNS(SVG_SPEC_URL, 'svg');
    const rectElement = frameDocument.createElementNS(SVG_SPEC_URL, 'rect');

    svgElement.setAttribute('class', 'rs-spotlight');
    svgElement.setAttribute('width', rect.width);
    svgElement.setAttribute('height', rect.height);
    svgElement.classList.add('spotlight');
    svgElement.style.top = `${rect.top - frameDocumentRect.top}px`;
    svgElement.style.left = `${rect.left - frameDocumentRect.left}px`;

    rectElement.setAttribute('width', rect.width);
    rectElement.setAttribute('height', rect.height);

    svgElement.appendChild(rectElement);

    frameDocument.documentElement.appendChild(svgElement);

    svgElements.push(svgElement);
  }

  const removeSvgElements = () => {
    svgElements.forEach((svgElement) => {
      svgElement?.parentElement?.removeChild(svgElement);
    });
  };

  // Animate the spotlight
  svgElements.forEach((svgElement) => {
    // Immediately zoom the element.
    setTimeout(() => {
      svgElement.style.transform = `scale(1)`;
    }, 1);

    // After seven seconds, start to fade out.
    setTimeout(() => {
      svgElement.style.opacity = `0`;
    }, 7000);
  });

  // After the elements have faded, remove it.
  setTimeout(removeSvgElements, 12000);

  // Automatically remove element if the window resizes
  window.addEventListener('resize', removeSvgElements);

  return removeSvgElements;
};

export default shineSpotlight;
